import { useState } from 'react';

const BoxModelVisualizer = () => {
  const [margin, setMargin] = useState(20);
  const [border, setBorder] = useState(4);
  const [padding, setPadding] = useState(20);
  const [width, setWidth] = useState(120);
  const [height, setHeight] = useState(80);

  const Slider = ({ label, value, onChange, max, color }) => (
    <div className="flex items-center gap-3 mb-2">
      <span className="text-xs font-mono w-16" style={{ color }}>{label}</span>
      <input
        type="range" min="0" max={max} value={value}
        onChange={e => onChange(parseInt(e.target.value))}
        className="flex-1 h-2 rounded-full appearance-none cursor-pointer"
        style={{ accentColor: color }}
        data-testid={`box-slider-${label.toLowerCase()}`}
      />
      <span className="text-xs font-mono text-white w-8 text-right">{value}px</span>
    </div>
  );

  return (
    <div className="my-6 bg-[#121225]/80 border border-white/10 rounded-2xl p-6" data-testid="box-model-visualizer">
      <h3 className="text-lg font-bold font-outfit text-white mb-4">Interactive Box Model</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Slider label="Margin" value={margin} onChange={setMargin} max={60} color="#ffa657" />
          <Slider label="Border" value={border} onChange={setBorder} max={20} color="#ffe47e" />
          <Slider label="Padding" value={padding} onChange={setPadding} max={60} color="#88ff88" />
          <Slider label="Width" value={width} onChange={setWidth} max={200} color="#79c0ff" />
          <Slider label="Height" value={height} onChange={setHeight} max={200} color="#79c0ff" />
        </div>

        <div className="flex items-center justify-center">
          {/* Margin layer */}
          <div
            className="flex items-center justify-center relative"
            style={{
              padding: margin,
              background: 'rgba(255, 166, 87, 0.15)',
              border: '1px dashed rgba(255, 166, 87, 0.5)',
              borderRadius: 8,
            }}
          >
            <span className="absolute top-1 left-2 text-[10px] font-mono text-[#ffa657]">margin</span>

            {/* Border layer */}
            <div
              className="flex items-center justify-center relative"
              style={{
                borderWidth: border,
                borderStyle: 'solid',
                borderColor: '#ffe47e',
                borderRadius: 4,
              }}
            >
              {border > 2 && <span className="absolute top-0 left-1 text-[10px] font-mono text-[#ffe47e]">border</span>}

              {/* Padding layer */}
              <div
                className="flex items-center justify-center relative"
                style={{
                  padding: padding,
                  background: 'rgba(136, 255, 136, 0.12)',
                }}
              >
                {padding > 10 && <span className="absolute top-1 left-1 text-[10px] font-mono text-[#88ff88]">padding</span>}

                {/* Content */}
                <div
                  className="flex items-center justify-center"
                  style={{
                    width,
                    height,
                    background: 'rgba(121, 192, 255, 0.2)',
                    border: '1px dashed rgba(121, 192, 255, 0.5)',
                    borderRadius: 2,
                  }}
                >
                  <span className="text-[10px] font-mono text-[#79c0ff]">
                    {width}x{height}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxModelVisualizer;
